import { Box } from '@chakra-ui/react';

import { CertifiedBadge } from './CertifiedBadge';
import FileDocumentIcon from './FileDocumentIcon';
import type { FileIconProps } from './FileIcon';

function FileCertifiedIcon({ size = 28, ...props }: FileIconProps) {
  return (
    <Box position='relative'>
      <Box position='absolute' left={`-${size / 4}px`} top={`-${size / 8}px`}>
        <CertifiedBadge size={size} {...props} />
      </Box>
      <Box>
        <FileDocumentIcon size={size} {...props} />
      </Box>
    </Box>
  );
}

export default FileCertifiedIcon;
